<script>
import { Pie, mixins } from 'vue-chartjs'

export default Pie.extend({
  props: [ 'chartData', 'options' ],
  mixins: [ mixins.reactiveProp ],
  mounted () {
    this.renderChart(this.chartData, this.options || {})
  }
})
</script>



// WEBPACK FOOTER //
// PieChart.vue?5a552d64